<div class="container">
    <div class="containerMessage">
        <img src="assets/img/acciona-transparent.png" alt="Logo Acciona" class="logo" />
        <p class="text">{{ 'PAGE.PERMISSIONS.PAGE_UNDER_CONSTRUCTION' | translate }}</p>
        <button (click)="onClickReturnToHome()" class="login-button">{{ 'PAGE.ACTIONS.RETURN_TO_MAIN_PAGE' | translate }}</button>
    </div>
</div>
